export default __webpack_public_path__ + "static/media/el_uslugi_main_square.9ca2b2d2.png";